import * as ActionsTypes from './RestaurantsWidgetsSettingsTypes';
import { IRestaurantsWidgetsSettingsActions } from './IRestaurantsWidgetsSettingsActions';
import { IRestaurantWidgetsSettings } from '../../types/IRestaurantWidgetsSettingsStore';

export function updateWidgetsSettings(
  data: Partial<IRestaurantWidgetsSettings>
): IRestaurantsWidgetsSettingsActions {
  return {
    type: ActionsTypes.UPDATE_WIDGETS_SETTINGS_REQUEST,
    payload: data,
  };
}

export function updateWidgetsSettingsSuccess(data: IRestaurantWidgetsSettings): IRestaurantsWidgetsSettingsActions {
  return {
    type: ActionsTypes.UPDATE_WIDGETS_SETTINGS_SUCCESS,
    payload: data,
  };
}

export function updateWidgetsSettingsError(): IRestaurantsWidgetsSettingsActions {
  return {
    type: ActionsTypes.UPDATE_WIDGETS_SETTINGS_ERROR,
    error: 'Не удалось переключить показа количества доступных столов в виджете',
  };
}

export function getWidgetsSettings(): IRestaurantsWidgetsSettingsActions {
  return {
    type: ActionsTypes.GET_WIDGETS_SETTINGS_REQUEST
  };
}

export function getWidgetsSettingsSuccess(data: IRestaurantWidgetsSettings): IRestaurantsWidgetsSettingsActions {
  return {
    type: ActionsTypes.GET_WIDGETS_SETTINGS_SUCCESS,
    payload: data,
  };
}

export function getWidgetsSettingsError(): IRestaurantsWidgetsSettingsActions {
  return {
    type: ActionsTypes.GET_WIDGETS_SETTINGS_ERROR,
    error: 'Не удалось получить настройки виджетов',
  };
}